import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  font16,
  fontSize20,
  fontWeightMedium,
  fontWeightNormal,
} from 'approot/shared/styles/typography.style';
import { grey4, grey10 } from 'approot/shared/styles/colours.style';
import { standardFocusStateInset } from 'approot/shared/styles/borders.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';

type AccordionPanelProps = {
  $withDividers?: boolean;
};
export const AccordionPanel = styled.div<AccordionPanelProps>`
  ${({ $withDividers }) =>
    $withDividers && `border-bottom: 1px solid ${grey4};`}
`;

type AccordionContentProps = {
  $isExpanded: boolean;
  $paddingBottom?: number;
};
export const AccordionContent = styled.div<AccordionContentProps>`
  display: block;

  ${({ $paddingBottom }) =>
    $paddingBottom &&
    `
    padding-bottom: ${rem($paddingBottom)};
  `}

  ${({ $isExpanded }) =>
    !$isExpanded &&
    `
      display: none;
      max-height: 0px;
      padding-bottom: 0px;
      padding-top: 0px;
      overflow: hidden;
  `}
`;

export const AccordionLabel = styled.span`
  ${font16}
  color: ${grey10};
  font-weight: ${fontWeightMedium};
  padding: ${rem(spacing8)} 0;
`;

export const AccordionHeading = styled.h2`
  margin-bottom: 0;
  position: relative;
`;

export const AccordionButton = styled.button.attrs({
  type: 'button',
})`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${rem(fontSize20)};
  font-weight: ${fontWeightNormal};
  text-align: left;
  padding: 0;
  position: relative;
  width: 100%;

  ${standardFocusStateInset}

  &:hover {
    cursor: pointer;
  }

  &:focus {
    z-index: 1;
  }
`;

export const AccordionButtonIcon = styled.div<AccordionContentProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: ${rem(32)};
  width: ${rem(32)};

  svg {
    fill: ${grey10};
    stroke: none;
    transition: transform 0.2s;
    transform: rotate(360deg);
  }

  ${({ $isExpanded }) =>
    $isExpanded &&
    `
    svg {
      transform: rotate(180deg);
    }
  `}

  @media print {
    display: none;
  }
`;
